export class StopwatchUtil {
  public static getElapsedSeconds(startTime: number): number {
    const endTime = Date.now();
    const timeDiffMilliseconds = endTime - startTime;
    const timeDiffSeconds = timeDiffMilliseconds / 1000.0;
    const roundedResult = Math.round(timeDiffSeconds * 1000) / 1000;
    return roundedResult;
  }
}
